import {api} from "./index";

export interface LoginFormData {
    login: string;
    password: string;
    rememberMe?: boolean;
}

export interface LoginResponse {
    message?: string;
    user?: any;
}

export async function loginAdmin(credentials: LoginFormData): Promise<LoginResponse> {
    try {
        const { rememberMe, ...adminCredentials } = credentials;
        const response = await api.post("/auth/login", {
            adminCredentials,
            rememberMe: !!rememberMe,
        });
        return response.data;
    } catch (error: any) {
        if (error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        throw new Error(error.message || "Ошибка авторизации");
    }
}

export async function checkAdminAuth(): Promise<boolean> {
    try {
        const response = await api.get("/auth/check");
        return response.status === 204;
    } catch (err: any) {
        return false;
    }
}

export async function logoutAdmin() {
    try {
        await api.post("/auth/logout");
    } catch (err) {
    }
}
